import axios from "axios";
import { enum_api_uri } from "../utils/enum";

export const downloadBLImage = async (s_bl_no: string, fileName = "BL 이미지.jpg") => {
    try {
        const response = await axios.get(`${enum_api_uri.customer_bl_down}/${s_bl_no}`, {
            responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const safeFilename = fileName.replace(/\s+/g, "");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", safeFilename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error("이미지 다운로드 중 오류 발생:", error);
    }
};
